// extracted by mini-css-extract-plugin
export var label = "style-module--label--1bb0d";
export var required = "style-module--required--bde3c";